// extracted by mini-css-extract-plugin
module.exports = {"phone__icon":"_Header_phone__icon__2xHWv","home":"_Header_home__3lAVS","btn":"_Header_btn__25lav","btn__container":"_Header_btn__container__nbJMF"};